/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Image = {
  imageRef?: string;
  imageBinary?: Array<string>;
  imageContent?: Image.imageContent;
};

export namespace Image {
  export enum imageContent {
    MAP = 'MAP',
    GRAPHIC = 'GRAPHIC',
    LOGO = 'LOGO',
  }
}
